










import Vue from "vue";

export default Vue.extend({
  name: "vc-image-modal-view",
  props: {
    dataSrc: {
      type: String,
      default: ""
    },
    addClass: {
      type: String,
      default: ""
    }
  }
});
